const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

export function normalizeOffer(item) {
  const offer = item?.oferta && typeof item.oferta === "object" ? item.oferta : {};
  const parsedEnd = Date.parse(offer.terminaEn || "");
  return {
    activa: offer.activa === true,
    precio: Math.max(0, Number(offer.precio || 0)),
    terminaEn: Number.isFinite(parsedEnd) ? new Date(parsedEnd).toISOString() : "",
  };
}

export function withNormalizedOffer(item) {
  return { ...item, oferta: normalizeOffer(item) };
}

export function getOfferState(item, now = Date.now()) {
  const basePrice = Math.max(0, Number(item?.precio || 0));
  const offer = normalizeOffer(item);
  const endsAt = Date.parse(offer.terminaEn || "");
  const isActive = offer.activa
    && Number.isFinite(endsAt)
    && endsAt > now
    && offer.precio >= 0
    && offer.precio < basePrice;
  const remainingMs = isActive ? Math.max(0, endsAt - now) : 0;
  const percentage = isActive && basePrice > 0
    ? Math.max(1, Math.round((1 - offer.precio / basePrice) * 100))
    : 0;
  return {
    isActive,
    basePrice,
    price: isActive ? offer.precio : basePrice,
    endsAt: Number.isFinite(endsAt) ? endsAt : null,
    remainingMs,
    percentage,
  };
}

export function getEffectivePrice(item, now = Date.now()) {
  return getOfferState(item, now).price;
}

export function formatOfferCountdown(remainingMs) {
  const totalSeconds = Math.max(0, Math.ceil(Number(remainingMs || 0) / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (days > 0) return `${days} ${days === 1 ? "día" : "días"} ${hours} h`;
  if (hours > 0) return `${hours} ${hours === 1 ? "hora" : "horas"} ${minutes} min`;
  if (minutes > 0) return `${minutes} min ${seconds} s`;
  return `${seconds} s`;
}

export function offerDurationFromNow(days = 0, hours = 0, now = Date.now()) {
  const duration = Math.max(0, Number(days || 0)) * DAY_MS
    + Math.max(0, Number(hours || 0)) * HOUR_MS;
  return duration > 0 ? new Date(now + duration).toISOString() : "";
}

export function toLocalDateTimeInput(value) {
  const date = new Date(value || "");
  if (Number.isNaN(date.getTime())) return "";
  const offset = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

export function fromLocalDateTimeInput(value) {
  const date = new Date(value || "");
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
}
